import {
  ACCOUNT_NO,
  ACCOUNT_CATEGORY,
  SUBLEDGER,
  SHORT_DESC,
  LONG_DESC,
  COMMENT,
  RECON_ACCOUNT,
  PROFIT_CENTER,
  ORDER_NUMBER,
  COST_CENTER,
  NO_DIRECT_POSTING,
  CLEARING_ACCOUNT,
  VIRTUAL_ACC,
  ALTERNATE_ACC,
  ALTERNATE_ACC_CUSTOM,
  GROUP_GL,
  OTHER_ALTERNATE_ACC,
} from "./consts";

import { z } from "zod";

export const schema = z.object({
  [ACCOUNT_NO]: z.string().optional(),
  [ACCOUNT_CATEGORY]: z.string().min(1, "This field is required"),
  [SUBLEDGER]: z.string().optional(),
  // [SUBLEDGER_TYPE]: z.string().min(1, "This field is required"),
  [SHORT_DESC]: z.string().min(1, "This field is required"),
  [LONG_DESC]: z.string().min(1, "This field is required"),
  [COMMENT]: z.string().optional(),
  [RECON_ACCOUNT]: z.boolean().optional(),
  [GROUP_GL]: z.boolean().optional(),
  [PROFIT_CENTER]: z.boolean().optional(),
  [ORDER_NUMBER]: z.boolean().optional(),
  [COST_CENTER]: z.boolean().optional(),
  [NO_DIRECT_POSTING]: z.boolean().optional(),
  [CLEARING_ACCOUNT]: z.boolean().optional(),
  [VIRTUAL_ACC]: z.string().optional(),
  [ALTERNATE_ACC]: z.string().optional(),
  [ALTERNATE_ACC_CUSTOM]: z.string().optional(),
}).superRefine((data, ctx) => {
  if (data[ALTERNATE_ACC] === OTHER_ALTERNATE_ACC && !data[ALTERNATE_ACC_CUSTOM]) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "This field is required",
      path: [ALTERNATE_ACC_CUSTOM],
    });
  }
});

export type formValues = z.infer<typeof schema>;
